import { registerTranslation } from '@nordhealth/components'
import i18next from 'i18next'
import I18NextVue from 'i18next-vue'
import { useNordTranslation } from '@/composables/useNordTranslation.js'

export default defineNuxtPlugin(async (nuxt) => {
  const [defaultApplicationTranslation, enUsApplicationTranslation] =
    await Promise.all([
      import('../locales/application.json'),
      import('../locales/en-US/application.json'),
    ])

  if (
    process.env.NODE_ENV !== 'production' ||
    process.env.MIRAGE_ENABLED === 'true'
  ) {
    const { i18nLogger } = await import('@/utils/dev-log/index.js')
    i18next.use(i18nLogger)
  }

  await i18next.init({
    lng: 'en-US',
    debug: process.env.NODE_ENV !== 'production',
    fallbackLng: (locale) =>
      locale === 'en-US' ? ['default'] : ['en-US', 'default'],
    ns: 'application',
    interpolation: {
      escapeValue: false, // Vue already handles escaping, so we don't need i18next to do it
      defaultVariables: {
        pageTitleConsultationId: '',
      },
    },
    resources: {
      default: {
        application: defaultApplicationTranslation.default,
      },
      'en-US': {
        application: enUsApplicationTranslation.default,
      },
    },
  })

  nuxt.vueApp.use(I18NextVue, { i18next })

  nuxt.hook('app:created', () => {
    const defaultNordTranslation = useNordTranslation('en-US')
    registerTranslation(defaultNordTranslation)
  })
})
